import { render, staticRenderFns } from "./DashFuncionarioVarejo.vue?vue&type=template&id=1ba42cba"
import script from "./DashFuncionarioVarejo.vue?vue&type=script&lang=js"
export * from "./DashFuncionarioVarejo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports